export default "__VITE_ASSET__IE8xbJ7u__"